/**
 * App
 * ------
 * Specify vendor and app specific js files to be compiled
 */

// Vendor Requires
require('./vendor/collapse');
require('./vendor/dropdown');
require('./vendor/modal');
require('./vendor/popover');
require('./vendor/validate.min');
require('./vendor/picturefill');
require('./vendor/js.cookie');
require('./vendor/slick.min');

// App Requires
require('./app/filter-bar');
require('./app/filter-bar-oxygen');
require('./app/faq-form');
require('./app/ga-tracking');
require('./app/search-form');
require('./app/tooltips');
require('./app/info-modal');
require('./app/sliders');